import mapClientToOption from 'ProjectManager/Project/DataManagement/GeneralInformation/Client/helpers/mapClientToOption';

const mapClientsToOptions = clients =>
    clients.map(client => mapClientToOption(client));

export default mapClientsToOptions;
